<template>
  <a-card :bordered="false">
    <!-- 搜索区域 -->
    <div class="table-page-search-wrapper" style="margin-bottom: 20px;">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :span="12">
            <a-form-item label="提交时间：" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
              <a-range-picker
                v-model="dateRange"
                valueFormat="YYYY-MM-DD"
                style="width: 100%;"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearchList" icon="search">查询</a-button>
              <a-button @click="handleResetSearch" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 表格区域 -->
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="list"
      :pagination="false"
      :loading="listLoading"
      :scroll="{ x: 2100 }"
    >
      <span slot="applyCount" slot-scope="text, record"><a @click="openOrderModal(record, 'apply')">{{ record.applyCount }}</a></span>
      <span slot="loanCount" slot-scope="text, record"><a @click="openOrderModal(record, 'loan')">{{ record.loanCount }}</a></span>
      <span slot="passA" slot-scope="text, record"><a @click="openOrderModal(record, 'passA')">{{ record.passCountA }}</a> / {{ record.passRateA }}</span>
      <span slot="passB" slot-scope="text, record"><a @click="openOrderModal(record, 'passB')">{{ record.passCountB }}</a> / {{ record.passRateB }}</span>
      <span slot="passC" slot-scope="text, record"><a @click="openOrderModal(record, 'passC')">{{ record.passCountC }}</a> / {{ record.passRateC }}</span>
      <span slot="loanA" slot-scope="text, record"><a @click="openOrderModal(record, 'loanA')">{{ record.loanCountA }}</a> / {{ record.loanRateA }}</span>
      <span slot="loanB" slot-scope="text, record"><a @click="openOrderModal(record, 'loanB')">{{ record.loanCountB }}</a> / {{ record.loanRateB }}</span>
      <span slot="loanC" slot-scope="text, record"><a @click="openOrderModal(record, 'loanC')">{{ record.loanCountC }}</a> / {{ record.loanRateC }}</span>
      <span slot="triple" slot-scope="text, record"><a @click="openOrderModal(record, 'triple')">{{ record.tripleCount }}</a> / {{ record.tripleRate }}</span>
      <span slot="double" slot-scope="text, record"><a @click="openOrderModal(record, 'double')">{{ record.doubleCount }}</a> / {{ record.doubleRate }}</span>
      <span slot="exclusiveA" slot-scope="text, record"><a @click="openOrderModal(record, 'exclusiveA')">{{ record.exclusiveA }}</a> / {{ record.exclusiveRateA }}</span>
      <span slot="exclusiveB" slot-scope="text, record"><a @click="openOrderModal(record, 'exclusiveB')">{{ record.exclusiveB }}</a> / {{ record.exclusiveRateB }}</span>
      <span slot="exclusiveC" slot-scope="text, record"><a @click="openOrderModal(record, 'exclusiveC')">{{ record.exclusiveC }}</a> / {{ record.exclusiveRateC }}</span>
      <span slot="overlapAB" slot-scope="text, record"><a @click="openOrderModal(record, 'overlapAB')">{{ record.overlapABCount }}</a> / {{ record.overlapABRate }}</span>
      <span slot="overlapAC" slot-scope="text, record"><a @click="openOrderModal(record, 'overlapAC')">{{ record.overlapACCount }}</a> / {{ record.overlapACRate }}</span>
      <span slot="overlapBC" slot-scope="text, record"><a @click="openOrderModal(record, 'overlapBC')">{{ record.overlapBCCount }}</a> / {{ record.overlapBCRate }}</span>
    </a-table>
    
    <a-modal title="订单号列表" :visible="modalVisible" @cancel="modalVisible = false" :footer="null">
      <div style="max-height: 400px; overflow-y: auto;">
        <p v-for="(orderObj, index) in currentOrderList" :key="index">
          <a @click="goToOrderDetail(orderObj)">{{ orderObj.orderSn || orderObj }}</a>
        </p>
        <p v-if="currentOrderList.length === 0">无数据</p>
      </div>
    </a-modal>
      <v-modal v-model="detailVisible" :title="'订单详情'">
      <div style="padding: 20px;" v-if="detailVisible">
        <order-detail :orderId="currentOrderId" :custInfoId="currentCustInfoId" :isQuerySummary="true"/>
      </div>
    </v-modal>
  </a-card>
</template>

<script>
import { getRiskConversionReport } from '@/api/riskReport'
import vModal from '../modules/Modal'
import OrderDetail from '../order/OrderDetail'

export default {
  name: 'riskReport',
  components: {
    vModal,
    OrderDetail
  },
  data() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const today = `${year}-${month}-${day}`;
    
    return {
      dateRange: [today, today],
      list: [],
      listLoading: false,
      modalVisible: false,
      detailVisible: false,
      currentOrderId: null,
      currentCustInfoId: null,
      currentMobileNo: null,
      currentOrderList: [],
      columns: [
        { title: '日期', dataIndex: 'submitDate', align: 'center', width: 100 },
        { title: '盘号', dataIndex: 'appSsid', align: 'center', width: 100 },
        { title: '申请数量', scopedSlots: { customRender: 'applyCount' }, align: 'center', width: 90 },
        { title: '总放款数', scopedSlots: { customRender: 'loanCount' }, align: 'center', width: 90 },
        { title: '总通过率', dataIndex: 'passRate', align: 'center', width: 90 },
        { title: '1-通过-率', scopedSlots: { customRender: 'passA' }, align: 'center', width: 100 },
        { title: '2-通过-率', scopedSlots: { customRender: 'passB' }, align: 'center', width: 100 },
        { title: '3-通过-率', scopedSlots: { customRender: 'passC' }, align: 'center', width: 100 },
        { title: 'A风控通过(放款)', scopedSlots: { customRender: 'loanA' }, align: 'center', width: 110 },
        { title: 'B回捞A(放款)', scopedSlots: { customRender: 'loanB' }, align: 'center', width: 120 },
        { title: 'C回捞AB(放款)', scopedSlots: { customRender: 'loanC' }, align: 'center', width: 120 },
        { title: '三重客户数/率', scopedSlots: { customRender: 'triple' }, align: 'center', width: 120 },
        { title: '2重客户数/率', scopedSlots: { customRender: 'double' }, align: 'center', width: 120 },
        { title: '1-独', scopedSlots: { customRender: 'exclusiveA' }, align: 'center', width: 100 },
        { title: '2-独', scopedSlots: { customRender: 'exclusiveB' }, align: 'center', width: 100 },
        { title: '3-独', scopedSlots: { customRender: 'exclusiveC' }, align: 'center', width: 100 },
        { title: 'AB重合数/率', scopedSlots: { customRender: 'overlapAB' }, align: 'center', width: 110 },
        { title: 'AC重合数/率', scopedSlots: { customRender: 'overlapAC' }, align: 'center', width: 110 },
        { title: 'BC重合数/率', scopedSlots: { customRender: 'overlapBC' }, align: 'center', width: 110 }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    openOrderModal(record, type) {
      if (record.detailOrders && record.detailOrders[type]) {
        this.currentOrderList = record.detailOrders[type];
      } else {
        this.currentOrderList = [];
      }
      this.modalVisible = true;
    },
    goToOrderDetail(orderObj) {
      this.modalVisible = false;
      if (typeof orderObj === 'string') {
        // Fallback
        this.$router.push({ path: '/order/allorderlist', query: { orderNo: orderObj } })
      } else {
        this.currentOrderId = orderObj.orderId;
        this.currentCustInfoId = orderObj.custInfoId;
        this.detailVisible = true;
      }
    },
    handleResetSearch() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const today = `${year}-${month}-${day}`;
      
      this.dateRange = [today, today]
      this.getList()
    },
    handleSearchList() {
      this.getList()
    },
    getList() {
      this.listLoading = true;
      let params = {};
      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0] + ' 00:00:00';
        params.endDate = this.dateRange[1] + ' 23:59:59';
      }
      getRiskConversionReport(params).then(res => {
        this.listLoading = false;
        if (res.code === 1000) {
          // ensure rowKey uses an index if id doesn't exist
          this.list = (res.data || res.result || []).map((item, index) => {
            item.id = index;
            return item;
          });
        } else {
          this.$message.error(res.message || res.msg || '获取数据失败');
        }
      }).catch(() => {
        this.listLoading = false;
      })
    }
  }
}
</script>

<style scoped>
</style>
